
function initialState()
{
    return {
        clients: []
    }
}

const getters = {
    clients: state => state.clients || [],
    client: state => id => {
        let client = state.clients.find((item) => { return item.id == id; });
        return client || null;
    },
    favorites: state => id => {
        let client = state.clients.find((item) => { return item.id == id; });
        if (client && client.favorites) {
            return client.favorites.length ? client.favorites : [];
        } else {
            return null;
        }
    }
};

const actions = {
    setClient({ commit }, id, value) {
        commit('setClient', id, value)
    },
    resetState({ commit }) {
        commit('resetState')
    }
};

const mutations = {
    setClient(state, value) {
        const filterItems = (value) => {
            return state.clients.filter((item) => value.id !== item.id)
        };
        state.clients = filterItems(value);
        state.clients.push(value);
    },
    resetState(state) {
        state = Object.assign(state, initialState())
    }
};

export default {
        namespaced: true,
        state: initialState,
        getters,
        actions,
        mutations
    }



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/Clients.js